import { Pagination, Typography } from "@mui/material";
import { AiFillPlusCircle } from "react-icons/ai";

import PageCountSelect from "../PageCountSelect";
import CustomButton from "../CustomButton";
import CustomSearchInput from "..//CustomInput/CustomSearchInput";

import "./style.css";
import CustomSort from "../CustomSort";
import { useState } from "react";
import { useEffect } from "react";
import CustomSelect from "../CustomSelect";

function CustomTableV2({
    title = "",
    description = "",
    table = {},
    store,
    actions,
    withPagination = true,
    withSearch = true,
    defaultPage = 1,
    defaultPerPage = 10,
}) {

    const [page, setPage] = useState(defaultPage)
    const [perPage, setPerPage] = useState(defaultPerPage)
    const [sort, setSort] = useState(null)
    const [search, setSearch] = useState()
    const [filter, setFilter] = useState()

    const getList = () => {
        actions?.get && actions.get(page, perPage, { search: search, [filter?.key]: filter?.value }, sort)
    }

    const paginate = (e, page) => {
        setPage(page)
    }

    const sortTable = (key, order) => {
        setSort({ column: key, order: order });
    }

    const searchData = () => {
        getList();
    }

    const capitalizeWords = (text) => {
        return text
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }

    useEffect(() => {
        getList();
    }, []);

    useEffect(() => {
        getList();
    }, [sort, page, perPage, filter]);

    return (
        <div id="custom-table">
            <div id="custom-table-wrapper">
                <div id="ctw-header">
                    <div id="ctw-title">
                        <h5>{capitalizeWords(title)}</h5>
                        <p>{capitalizeWords(description)}</p>
                    </div>
                    <div id="ctw-actions">

                        <div>
                            {
                                actions.filter && <CustomSelect placeholder={actions.filter?.name} options={actions.filter?.options} onChange={(e) => {
                                    setFilter(f => {
                                        return {
                                            key: actions.filter?.key,
                                            value: e.target.value,
                                        }
                                    });
                                }} />
                            }
                        </div>
                        {
                            withSearch && <CustomSearchInput
                                handleChange={(e) => {
                                    const val = e.target.value;

                                    setSearch(val);

                                    if (val.length > 3) {
                                        searchData();
                                    }

                                }} onclick={() => {
                                    searchData();
                                }}
                            />
                        }
                        <div>
                            {actions.add && <CustomButton onClick={actions.add}><AiFillPlusCircle />Add</CustomButton>}
                        </div>
                        <div>
                            {actions.qr && <CustomButton onClick={actions.qr}>SHOW QR</CustomButton>}
                        </div>
                    </div>
                </div>
                <div id="ctw-table">
                    <table>
                        <thead>
                            <tr>
                                {
                                    table.headers.map(({ title, value }, i) => {
                                        return (
                                            <th>
                                                <div>
                                                    <h5>
                                                        {capitalizeWords(title)}
                                                    </h5>
                                                    {
                                                        value && <CustomSort active={(sort && sort.column == value) ? sort.order : null} Sort={(sortType) => {
                                                            sortTable(value, sortType);
                                                        }} />
                                                    }
                                                </div>
                                            </th>
                                        )
                                    })
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                store?.list && store?.list.map(
                                    (item, i) => {
                                        return (
                                            table.body(
                                                item,
                                                ((page - 1) * perPage) + (i + 1),
                                            )
                                        )
                                    })
                            }
                        </tbody>
                    </table>
                </div>
                {
                    withPagination && <div id="ctw-footer-actions">
                        <div style={{ display: "flex", marginTop: "10px" }}>
                            <div>
                                <Typography style={{ marginRight: "10px" }}>Total: {store?.count}</Typography>
                                <Typography style={{ marginRight: "10px" }}>Page: {page} of {(Math.ceil(store?.count / perPage) || 0)}</Typography>
                            </div>
                            <PageCountSelect onChange={(val) => {
                                setPerPage(val);
                            }} />
                        </div>
                        <Pagination count={Math.ceil(store?.count / perPage)} page={page} variant="outlined" shape="rounded" onChange={paginate} />
                    </div>
                }

            </div>
        </div>
    );
}

export default CustomTableV2;